module.exports = __webpack_public_path__ + "static/logo_en-298f930dca2da2c52cb8765a49dcab81.png";